import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import type { QueryClient } from '@tanstack/react-query'
import { UpdateAutoApply, UpdateChecker, UpdateToast } from '@/components/UpdateNotice'
import { Toaster } from '@/components/Toaster'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  return (
    <>
      <UpdateChecker />
      <UpdateAutoApply />
      <div className="min-h-screen bg-gray-50 no-select">
        <Outlet />
      </div>
      <UpdateToast />
      <Toaster />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
